var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-object",style:({ top: _vm.position.y + 'px', left: _vm.position.x + 'px', transform: 'rotate(' + _vm.rotateDeg + 'deg)'})},[_vm._v(" "+_vm._s(_vm.objectName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }